import styled, { keyframes } from "styled-components";

export const DashboardContainer = styled.div`
  min-height: 100vh;
  background-color: ${(props) => (props.isDarkMode ? "#1a202c" : "#f5f7fb")};
  display: flex;
  width: 100vw;
  max-width: 100vw;
  overflow-x: hidden;
  box-sizing: border-box;
  transition: background-color 0.3s ease;
`;

export const MainContent = styled.div`
  flex: 1;
  margin-left: ${(props) => (props.isSidebarCollapsed ? "80px" : "260px")};
  overflow: scroll;
  padding: 1rem;
  transition: margin-left 0.3s ease;
  min-height: 100vh;
  box-sizing: border-box;

  @media (max-width: 768px) {
    margin-left: 0;
    padding: 0.7rem;
    width: 100vw;
    max-width: 100vw;
    overflow-x: hidden;
  }
`;

export const MobileOverlay = styled.div`
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;

  @media (max-width: 768px) {
    display: ${(props) => (props.isOpen ? "block" : "none")};
  }
`;

// ----------Side Bar ----------------

export const Sidebar = styled.div`
  width: ${(props) => (props.isCollapsed ? "80px" : "260px")};
  background: ${(props) => (props.isDarkMode ? "#2d3748" : "#fff")};
  box-shadow: 0 0 20px
    rgba(0, 0, 0, ${(props) => (props.isDarkMode ? "0.3" : "0.05")});
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  padding: 1.5rem 0;
  display: flex;
  flex-direction: column;
  z-index: 1000;
  transition: width 0.3s ease, transform 0.3s ease, background 0.3s ease;
  overflow-y: auto;
  overflow-x: hidden;

  @media (max-width: 768px) {
    width: 100vw;
    max-width: 100vw;
    transform: ${(props) =>
      props.isOpen ? "translateX(0)" : "translateX(-100%)"};
    box-sizing: border-box;
  }
`;

export const SidebarHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.isCollapsed ? "center" : "flex-start")};
  padding: 1rem;
  border-bottom: 1px solid
    ${(props) => (props.isDarkMode ? "#4a5568" : "#f1f3f9")};
  min-height: 60px;
  transition: border-color 0.3s ease;

  @media (max-width: 768px) {
    justify-content: flex-start;
  }
`;

export const SidebarLogo = styled.img`
  height: 32px;
  transition: opacity 0.3s ease, transform 0.3s ease;
`;

export const SidebarMenuIcon = styled.div`
  font-size: 1.8rem;
  color: #667eea;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;

  &:hover {
    color: #764ba2;
    transform: scale(1.1);
  }

  svg {
    font-weight: 700;
    stroke-width: 2.5px;
  }
`;

export const SidebarCollapseButton = styled.button`
  background: transparent;
  border: none;
  color: ${(props) => (props.isDarkMode ? "#cbd5e0" : "#667eea")};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  margin-left: 8px;
  border-radius: 6px;
  transition: transform 0.18s ease, color 0.18s ease;
  font-size: 1.8rem;
  stroke-width: 2.5px;

  &:hover {
    transform: scale(1.05);
    color: #764ba2;
  }
`;

export const SidebarNav = styled.nav`
  flex: 1;
  padding: 1.5rem 0;
`;

export const SidebarLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.isCollapsed ? "center" : "flex-start")};
  padding: ${(props) => (props.isCollapsed ? "0.8rem" : "0.8rem 1.5rem")};
  color: ${(props) =>
    props.active ? "#667eea" : props.isDarkMode ? "#cbd5e0" : "#4a5568"};
  font-weight: 500;
  transition: all 0.3s ease;
  background: ${(props) =>
    props.active
      ? "linear-gradient(90deg, rgba(102, 126, 234, 0.2), rgba(118, 75, 162, 0.2))"
      : "transparent"};
  border-left: 3px solid
    ${(props) => (props.active ? "#667eea" : "transparent")};
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;

  &:hover {
    background: ${(props) =>
      props.active
        ? "linear-gradient(90deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1))"
        : props.isDarkMode
        ? "#4a5568"
        : "#f8f9fd"};
  }

  svg {
    margin-right: ${(props) => (props.isCollapsed ? "0" : "12px")};
    color: ${(props) => (props.active ? "#667eea" : "#a0aec0")};
    font-size: 1.2rem;
    flex-shrink: 0;
  }

  @media (max-width: 768px) {
    justify-content: flex-start;
    padding: 0.8rem 1.5rem;

    svg {
      margin-right: 12px;
    }
  }
`;

export const SidebarFooter = styled.div`
  padding: 1rem;
  border-top: 1px solid ${(props) => (props.isDarkMode ? "#4a5568" : "#f1f3f9")};
  transition: border-color 0.3s ease;
`;

export const SidebarUser = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.isCollapsed ? "center" : "flex-start")};
  margin-bottom: 1rem;
  overflow: hidden;

  @media (max-width: 768px) {
    justify-content: flex-start;
  }
`;

export const SidebarUserAvatar = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #764ba2;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: ${(props) => (props.isCollapsed ? "0" : "12px")};
  font-weight: 600;
  font-size: 1rem;
  flex-shrink: 0;

  @media (max-width: 768px) {
    margin-right: 12px;
  }
`;

export const SidebarUserInfo = styled.div`
  flex: 1;
  display: ${(props) => (props.isCollapsed ? "none" : "block")};
  overflow: hidden;
  transition: all 0.3s ease;

  @media (max-width: 768px) {
    display: block;
  }
`;

export const SidebarUserName = styled.div`
  text-transform: capitalize;
  font-weight: 600;
  color: ${(props) => (props.isDarkMode ? "#e2e8f0" : "#2d3748")};
  font-size: 0.95rem;
  transition: color 0.3s ease;
`;

export const SidebarUserRole = styled.div`
  font-size: 0.8rem;
  color: #a0aec0;
`;

export const SidebarLogoutButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.isCollapsed ? "center" : "flex-start")};
  width: 100%;
  padding: 0.8rem 1rem;
  color: #e53935;
  background: rgba(229, 57, 53, 0.1);
  border: none;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  overflow: hidden;

  &:hover {
    background: rgba(229, 57, 53, 0.15);
  }

  svg {
    margin-right: ${(props) => (props.isCollapsed ? "0" : "8px")};
    font-size: 1.2rem;
    flex-shrink: 0;
  }

  @media (max-width: 768px) {
    justify-content: flex-start;

    svg {
      margin-right: 8px;
    }
  }
`;

// -------------------------Header Styles -----------------------

export const ContentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  flex-wrap: wrap;
  gap: 1rem;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    margin-bottom: 1.5rem;
    gap: 1rem;
  }
`;

export const PageTitle = styled.h1`
  font-size: 1.8rem;
  font-weight: 700;
  color: ${(props) => (props.isDarkMode ? "#e2e8f0" : "#333")};
  margin: 0;
  background: ${(props) =>
    props.isDarkMode
      ? "linear-gradient(90deg, #9f7aea, #b794f6)"
      : "linear-gradient(90deg, #667eea, #764ba2)"};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  transition: color 0.3s ease;

  @media (max-width: 1024px) {
    font-size: 1.5rem;
    text-align: center;
  }
  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
`;

export const SearchContainer = styled.div`
  position: relative;
  width: 300px;
  flex-shrink: 0;

  @media (max-width: 1024px) {
    width: 100%;
    max-width: 100%;
    flex: 1;
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 0.7rem 1rem 0.7rem 2.5rem;
  border: 1px solid ${(props) => (props.isDarkMode ? "#4a5568" : "#e1e5ee")};
  border-radius: 8px;
  font-size: 0.9rem;
  background-color: ${(props) => (props.isDarkMode ? "#2d3748" : "white")};
  color: ${(props) => (props.isDarkMode ? "#e2e8f0" : "#333")};
  transition: all 0.2s;

  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
  }

  &::placeholder {
    color: ${(props) => (props.isDarkMode ? "#a0aec0" : "#a0aec0")};
  }
`;

export const SearchIcon = styled.span`
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  color: #a0aec0;
`;

export const StatusFilterContainer = styled.div`
  position: relative;
  min-width: 150px;

  @media (max-width: 768px) {
    min-width: 120px;
  }
`;

export const StatusFilterSelect = styled.select`
  width: 100%;
  padding: 0.7rem 1rem;
  border: 1px solid ${(props) => (props.isDarkMode ? "#4a5568" : "#e1e5ee")};
  border-radius: 8px;
  font-size: 0.9rem;
  background-color: ${(props) => (props.isDarkMode ? "#2d3748" : "white")};
  color: ${(props) => (props.isDarkMode ? "#e2e8f0" : "#333")};
  cursor: pointer;
  transition: all 0.2s;

  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
  }

  @media (max-width: 768px) {
    padding: 0.6rem 0.8rem;
    font-size: 0.8rem;
  }
`;

export const RefetchButton = styled.button`
  width: 100%;
  max-width: max-content;
  background: linear-gradient(90deg, #667eea, #764ba2);
  color: white;
  border: none;
  padding: 0.7rem 1.2rem;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(102, 126, 234, 0.2);
  flex-shrink: 0;
  white-space: nowrap;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(102, 126, 234, 0.3);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }

  svg {
    animation: ${(props) =>
      props.loading ? "spin 1s linear infinite" : "none"};
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  @media (max-width: 768px) {
    width: 100%;
    min-width: 100%;
    justify-content: center;
    padding: 0.8rem 1.2rem;
    flex-shrink: 0;
  }
`;
export const DesktopHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media (max-width: 768px) {
    display: none;
  }
`;
export const MobileHeaderTop = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1rem;
  }
`;

export const MobileHeaderBottom = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    align-items: center;
    width: 100%;

    /* Make the 3rd child full width on separate line */
    & > *:nth-child(3) {
      grid-column: 1 / -1;
      width: 100%;
    }
    @media (max-width: 768px) {
      gap: 0.8rem;
    }
  }
`;

export const MobileMenuButton = styled.button`
  display: none;
  background: linear-gradient(90deg, #667eea, #764ba2);
  color: white;
  border: none;
  padding: 0.5rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1.2rem;
  margin-bottom: 1rem;
  z-index: 1001;
  position: ${(props) => (props.isOpen ? "absolute" : "relative")};
  top: ${(props) => (props.isOpen ? "1rem" : "auto")};
  right: ${(props) => (props.isOpen ? "1rem" : "auto")};

  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    min-width: 44px;
    min-height: 44px;
    margin-bottom: 0rem;
  }
`;

// --------------------------Table Styles -----------------
export const TableContainer = styled.div`
  background-color: ${(props) => (props.isDarkMode ? "#2d3748" : "white")};
  border-radius: 8px;
  box-shadow: 0 2px 8px
    rgba(0, 0, 0, ${(props) => (props.isDarkMode ? "0.3" : "0.1")});
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  box-sizing: border-box;
  transition: background-color 0.3s ease;
  --orders-col-1-width: clamp(70px, 7vw, 110px);
  --orders-col-2-width: clamp(70px, 7vw, 110px);
  --orders-col-3-width: clamp(70px, 7vw, 110px);
  --orders-col-4-width: clamp(80px, 8vw, 130px);
  --orders-col-5-width: clamp(70px, 7vw, 110px);
  --orders-col-6-width: clamp(80px, 8vw, 130px);
  --orders-col-7-width: clamp(90px, 9vw, 150px);
  --orders-col-8-width: clamp(60px, 6vw, 100px);
  --orders-col-9-width: clamp(60px, 6vw, 100px);
  --orders-col-10-width: clamp(90px, 9vw, 160px);
  --orders-col-11-width: clamp(90px, 9vw, 180px);

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }

  @media (max-width: 768px) {
    border-radius: 6px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
    overflow-x: visible; /* No scroll on mobile - use card layout */
  }
`;

export const StyledTable = styled.table`
  width: 100%;
  min-width: max-content;
  border-collapse: collapse;
  table-layout: auto;

  @media (max-width: 768px) {
    min-width: 100%;
    display: none;

    /* Mobile responsive card layout */
    thead {
      display: none;
    }

    tbody tr {
      display: block;
      margin-bottom: 1rem;
      border: 1px solid #e1e5ee;
      border-radius: 8px;
      padding: 1rem;
      background: white;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    }

    /* Status-based border colors */
    tbody tr[data-status="completed"] {
      border-left: 4px solid #4caf50;
    }

    tbody tr[data-status="processing"] {
      border-left: 4px solid #ff9800;
    }

    tbody tr[data-status="pending"] {
      border-left: 4px solid #03a9f4;
    }

    tbody tr[data-status] {
      border-left: 4px solid #9e9e9e;
    }

    tbody td {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.75rem 0.5rem;
      border: none;
      border-bottom: 1px solid #f5f5f5;
      font-size: 0.85rem;

      &:last-child {
        border-bottom: none;
      }

      &::before {
        content: attr(data-label);
        font-weight: 600;
        color: #4a5568;
        margin-right: 1rem;
        flex-shrink: 0;
        font-size: 0.8rem;
        min-width: 120px;
      }
    }
  }
`;

export const TableHeader = styled.thead`
  background-color: ${(props) => (props.isDarkMode ? "#1a202c" : "#f8f9fa")};
  border-bottom: 2px solid
    ${(props) => (props.isDarkMode ? "#4a5568" : "#e1e5ee")};
  transition: background-color 0.3s ease, border-color 0.3s ease;
`;

export const TableHeaderCell = styled.th`
  padding: 0.75rem 0.5rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.85rem;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  color: ${(props) => (props.isDarkMode ? "#e2e8f0" : "#333")};
  transition: color 0.3s ease;

  /* Specific column widths for better distribution */
  &:nth-child() {
    width: 100%;
    min-width: max-content;
  } /* Order ID */
  // &:nth-child(2) {
  //   width: 100%;
  // min-width: max-content;
  // } /* Status */
  // &:nth-child(3) {
  //   min-width: 130px;
  //   width: 130px;
  // } /* EOS Status */
  // &:nth-child(4) {
  //   min-width: 120px;
  //   width: 120px;
  // } /* Street View */
  // &:nth-child(5) {
  //   min-width: 120px;
  //   width: 120px;
  // } /* Accuzip List */
  // &:nth-child(6) {
  //   min-width: 110px;
  //   width: 110px;
  // } /* Accuzip StartTime */
  // &:nth-child(7) {
  //   min-width: 200px;
  //   width: 200px;
  // } /* Accuzip EndTime */
  // &:nth-child(8) {
  //   min-width: 200px;
  //   width: 200px;
  // } /* Total */
  // &:nth-child(9) {
  //   min-width: 120px;
  //   width: 120px;
  // } /* Street View Done */
  // &:nth-child(10) {
  //   min-width: 210px;
  //   // width: 210px;
  // } /* Completion Date */
`;

/* Rest of your styles remain the same */
export const TableRow = styled.tr`
  border-bottom: 1px solid
    ${(props) => (props.isDarkMode ? "#4a5568" : "#e1e5ee")};
  transition: background-color 0.3s ease, border-color 0.3s ease;

  &:hover {
    background-color: ${(props) => (props.isDarkMode ? "#1a202c" : "#f8f9fa")};
  }

  @media (max-width: 768px) {
    display: block;
    border-bottom: none;

    &:hover {
      background-color: transparent;
    }
  }
`;

export const TableCell = styled.td`
  padding: 0.65rem 0.5rem;
  font-size: 0.9rem;
  white-space: normal;
  overflow-wrap: anywhere;
  color: ${(props) => (props.isDarkMode ? "#e2e8f0" : "#333")};
  transition: color 0.3s ease;

  &:nth-child(1) {
    width: var(--orders-col-1-width);
  }
  &:nth-child(2) {
    width: var(--orders-col-2-width);
  }
  &:nth-child(3) {
    width: var(--orders-col-3-width);
  }
  &:nth-child(4) {
    width: var(--orders-col-4-width);
  }
  &:nth-child(5) {
    width: var(--orders-col-5-width);
  }
  &:nth-child(6) {
    width: var(--orders-col-6-width);
  }
  &:nth-child(7) {
    width: var(--orders-col-7-width);
  }
  &:nth-child(8) {
    width: var(--orders-col-8-width);
  }
  &:nth-child(9) {
    width: var(--orders-col-9-width);
  }
  &:nth-child(10) {
    width: var(--orders-col-10-width);
  }
  &:nth-child(11) {
    width: var(--orders-col-11-width);
  }

  @media (max-width: 768px) {
    white-space: normal;
    display: flex;
  }
`;

export const StatusCell = styled(TableCell)`
  &:before {
    content: "";
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 8px;
    background-color: ${(props) => {
      switch (props.status?.toLowerCase()) {
        case "completed":
          return "#4caf50";
        case "processing":
          return "#ff9800";
        case "pending":
          return "#03a9f4";
        default:
          return "#9e9e9e";
      }
    }};
  }
`;

export const BooleanCell = styled(TableCell)`
  text-align: center;
  font-weight: 500;

  @media (max-width: 768px) {
    text-align: left;
  }
`;

export const EmptyState = styled.td`
  padding: 3rem 1rem;
  text-align: center;
  color: #666;
  font-style: italic;

  @media (max-width: 768px) {
    display: block;
    padding: 2rem 1rem;
  }
`;

// ---------------------Mobile Styles---------------------

export const MobileOrdersContainer = styled.div`
  display: none;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    display: block;
  }
`;

export const MobileOrderCard = styled.div`
  display: none;
  background: ${(props) => (props.isDarkMode ? "#2d3748" : "white")};
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
  box-shadow: 0 2px 4px
    rgba(0, 0, 0, ${(props) => (props.isDarkMode ? "0.3" : "0.1")});
  border-left: 4px solid
    ${(props) => {
      switch (props.status && props.status.toLowerCase()) {
        case "completed":
          return "#4caf50";
        case "processing":
          return "#ff9800";
        case "pending":
          return "#03a9f4";
        default:
          return "#9e9e9e";
      }
    }};
  transition: background-color 0.3s ease;

  @media (max-width: 768px) {
    display: block;
  }
`;

export const MobileCardRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const MobileCardLabel = styled.span`
  font-weight: 600;
  color: ${(props) => (props.isDarkMode ? "#cbd5e0" : "#4a5568")};
  font-size: 0.8rem;
  flex-shrink: 0;
  margin-right: 1rem;
  transition: color 0.3s ease;
`;

export const MobileCardValue = styled.span`
  color: ${(props) => (props.isDarkMode ? "#e2e8f0" : "#333")};
  font-size: 0.8rem;
  text-align: right;
  flex: 1;
  word-break: break-word;
  transition: color 0.3s ease;
`;

export const MobileCardStatus = styled.div`
  display: flex;
  align-items: center;
  font-size: 15px;
  gap: 0.5rem;
`;

// --------------------------------------------------
export const CellWithTooltipStyled = styled(TableCell)`
  position: relative;
  color: ${(props) => (props.isDarkMode ? "#e2e8f0" : "#333")};
  transition: color 0.3s ease;

  .cell-content {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: ${(props) => (props.hasTooltip ? "help" : "default")};
  }

  .tooltip {
    visibility: hidden;
    opacity: 0;
    background-color: #2d3748;
    color: white;
    padding: 0.5rem 0.75rem;
    border-radius: 6px;
    position: fixed;
    z-index: 10001;
    font-size: 0.85rem;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    transition: opacity 0.2s, visibility 0.2s;
    max-width: 400px;
    word-break: break-word;
    white-space: normal;

    &::after {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      border: 5px solid transparent;
      border-top-color: #2d3748;
    }
  }

  &:hover .tooltip {
    visibility: visible;
    opacity: 1;
  }
`;

export const HeaderCellWithFilter = styled(TableHeaderCell)`
  position: relative;
  overflow: visible;

  .header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
  }

  .header-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  padding-right: 22px; /* make room for resizer + small gap */

  .filter-wrapper {
    flex-shrink: 0;
    margin-right: 6px; /* small gap from content toward resizer */
  }

  .resizer {
    position: absolute;
    right: 0;
    top: 8px;
    height: calc(100% - 16px);
    width: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: col-resize;
    touch-action: none;
    z-index: 6;
  }

  .resizer::before {
    content: "";
    display: block;
    width: 2px;
    height: 60%;
    border-radius: 2px;
    background: ${(props) =>
      props.isDarkMode ? "rgba(255,255,255,0.14)" : "rgba(0,0,0,0.12)"};
    transition: background 120ms ease, transform 120ms ease;
  }

  &:hover .resizer::before,
  .resizer:hover::before {
    background: #667eea;
    transform: scaleY(1.06);
  }

  .sc-ixcdjX {
    border: unset;
    background-color: unset;
    box-shadow: unset;
  }
`;

// -------------------------Analytics Styles-------------------------
export const AnalyticsGrid = styled.div`
  display: grid;
  gap: 1.2rem;
  margin-bottom: 1.5rem;

  /* XL: 4 columns */
  @media (min-width: 1300px) {
    grid-template-columns: repeat(3, 1fr);
  }

  /* L: 3 columns */
  @media (min-width: 1024px) and (max-width: 1299px) {
    grid-template-columns: repeat(3, 1fr);
  }

  /* MD: 2 columns */
  @media (min-width: 768px) and (max-width: 1023px) {
    grid-template-columns: repeat(2, 1fr);
  }

  /* SM: 1 column */
  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    gap: 1rem;
    margin-bottom: 1.2rem;
  }
`;

export const AnalyticsCard = styled.div`
  background: ${(props) => (props.isDarkMode ? "#2d3748" : "white")};
  cursor: pointer;
  border-radius: 12px;
  box-shadow: 0 4px 10px
    rgba(0, 0, 0, ${(props) => (props.isDarkMode ? "0.3" : "0.05")});
  padding: 1rem 1.5rem 0.5rem 1.5rem;
  transition: all 0.3s ease, background-color 0.3s ease;
  border-left: 4px solid ${(props) => props.color || "#667eea"};

  &:hover {
    // transform: translateY(-5px);
    scale: 1.03;
    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);
    background-color: ${(props) => {
      const color = props.color || "#667eea";
      // Convert hex to rgba with 10% opacity
      const hex = color.replace("#", "");
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      return `rgba(${r}, ${g}, ${b}, 0.1)`;
    }};
  }

  @media (max-width: 768px) {
    padding: 1.25rem;
  }
`;

/* Rest of your styles remain the same */
export const AnalyticsCardHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
`;

export const AnalyticsCardIcon = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 10px;
  background-color: ${(props) => props.bgColor || "rgba(102, 126, 234, 0.1)"};
  color: ${(props) => props.iconColor || "#667eea"};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  margin-right: 1rem;
`;

export const AnalyticsCardTitle = styled.h3`
  margin: 0;
  color: ${(props) => (props.isDarkMode ? "#cbd5e0" : "#4a5568")};
  font-size: 0.9rem;
  font-weight: 500;
  transition: color 0.3s ease;
`;

export const AnalyticsCardValue = styled.div`
  font-size: 1.8rem;
  font-weight: 700;
  color: ${(props) => (props.isDarkMode ? "#e2e8f0" : "#2d3748")};
  transition: color 0.3s ease;
`;
// ------------------------ Pagination Styles ------------------------

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2rem;
  padding: 1rem;
  background-color: ${(props) => (props.isDarkMode ? "#2d3748" : "white")};
  border-radius: 12px;
  box-shadow: 0 2px 5px
    rgba(0, 0, 0, ${(props) => (props.isDarkMode ? "0.3" : "0.05")});
  flex-wrap: wrap;
  gap: 1rem;
  transition: background-color 0.3s ease;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    margin-top: 1.5rem;
    padding: 0.8rem;
    border-radius: 8px;
  }
`;

export const PaginationInfo = styled.div`
  color: ${(props) => (props.isDarkMode ? "#cbd5e0" : "#4a5568")};
  font-size: 0.9rem;
  transition: color 0.3s ease;

  @media (max-width: 768px) {
    font-size: 0.8rem;
    text-align: center;
  }
`;

export const PaginationControls = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  justify-content: center;

  @media (max-width: 768px) {
    gap: 0.3rem;
  }
`;

export const PageButton = styled.button`
  background: ${(props) =>
    props.active ? "#667eea" : props.isDarkMode ? "#2d3748" : "white"};
  color: ${(props) =>
    props.active ? "white" : props.isDarkMode ? "#e2e8f0" : "#4a5568"};
  border: 1px solid ${(props) => (props.isDarkMode ? "#4a5568" : "#e1e5ee")};
  width: 36px;
  height: 36px;
  border-radius: 6px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background: ${(props) =>
      props.active ? "#667eea" : props.isDarkMode ? "#4a5568" : "#f8f9fd"};
    border-color: #667eea;
  }

  @media (max-width: 768px) {
    width: 32px;
    height: 32px;
    font-size: 0.85rem;
  }
`;

export const PageNavigationButton = styled(PageButton)`
  width: auto;
  padding: 0 10px;

  @media (max-width: 768px) {
    padding: 0 8px;
    font-size: 0.8rem;
  }
`;

// ------------------- Utility Syles -------------------

export const ErrorMessage = styled.div`
  color: #e53935;
  background-color: rgba(229, 57, 53, 0.1);
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 2rem;
  font-weight: 500;
  display: flex;
  align-items: center;

  &:before {
    content: "⚠️";
    margin-right: 10px;
    font-size: 1.2rem;
  }
`;

// ------------- Skeleton style ----------------
// Add these exports to your LayoutStyles.js file
export const shimmer = keyframes`
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`;

export const SkeletonCell = styled.td`
  padding: 1.2rem 1rem;
  background-color: ${(props) =>
    props.isDarkMode ? "#2d3748" : "transparent"};
  transition: background-color 0.3s ease;
`;

export const SkeletonPulse = styled.div`
  display: inline-block;
  height: 16px;
  width: ${(props) => props.width || "80px"};
  background: ${(props) => (props.isDarkMode ? "#4a5568" : "#f6f7f8")};
  background-image: linear-gradient(
    to right,
    ${(props) =>
      props.isDarkMode
        ? "#4a5568 0%, #2d3748 20%, #4a5568 40%, #4a5568 100%"
        : "#f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%"}
  );
  background-repeat: no-repeat;
  background-size: 800px 104px;
  border-radius: 4px;
  animation: ${shimmer} 1.5s infinite linear;
  transition: background 0.3s ease;
`;

export const AnalyticsSkeletonValue = styled.div`
  height: 32px;
  width: 60px;
  background: ${(props) =>
    props.isDarkMode
      ? "linear-gradient(90deg, #4a5568 25%, #2d3748 50%, #4a5568 75%)"
      : "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)"};
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s infinite linear;
  border-radius: 4px;
  transition: background 0.3s ease;
`;

export const AnalyticsSkeletonGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
  margin-bottom: 2rem;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1rem;
    margin-bottom: 1.5rem;
  }
`;
